<template>
    <div class="grid-wrapper">
        <DxDataGrid ref="grid" :dataSource="oscilos" @rowDblClick="onRowDblClick" @contentReady="onContentReady"
            @selection-changed="onSelectionChanged" @exporting="onExporting" v-bind="getDefaultGridProperties()">
            <DxSelection mode="single" />
            <DxHeaderFilter :visible="true" />
            <DxFilterRow :visible="true" />
            <DxFilterPanel :visible="true" />
            <DxPaging :enabled="true" :pageSize="10" />
            <DxPager :visible="true" :allowed-page-sizes="[10, 20, 50, 'all']" display-mode="full"
                :show-page-size-selector="true" :show-info="true" :show-navigation-buttons="true" />
            <DxRemoteOperations :filtering="true" :paging="true" :sorting="true" :summary="true" :grouping="true"
                :group-paging="true" />
            <DxExport :enabled="true" v-if="vistaAdministracion" />
            <DxColumnChooser :enabled="true" v-if="vistaAdministracion" />
            <DxToolbar>
                <DxItem location="after" :caption="$t('oscilos.grid.toolbar.ver_oscilo')" template="btnVerOscilo"
                    v-if="tienePermisoOscilosVer(autho)" />
                <DxItem location="after" :caption="$t('oscilos.grid.toolbar.anadir_oscilo')" template="btnAnadirOscilo"
                    v-if="vistaAdministracion && tienePermisoOscilosAnadir(autho)" />
                <DxItem location="after" :caption="$t('oscilos.grid.toolbar.editar_oscilo')" template="btnEditarOscilo"
                    v-if="vistaAdministracion && tienePermisoOscilosEditar(autho)" />
                <DxItem location="after" :caption="$t('oscilos.grid.toolbar.dar_de_baja_oscilo')"
                    template="btnDarDeBajaOscilo" v-if="vistaAdministracion && tienePermisoOscilosEliminar(autho)" />
                <DxItem location="after" :caption="$t('oscilos.grid.toolbar.actualizar_rejilla')"
                    template="btnActualizarRejilla" />
                <DxItem location="after" :caption="$t('oscilos.grid.toolbar.restaurar_rejilla')"
                    template="btnRestaurarRejilla" />
                <DxItem location="after" name="exportButton" />
                <DxItem location="after" name="columnChooserButton" />
            </DxToolbar>
            <DxColumn data-field="Id" :visible="false" :show-in-column-chooser="false">
            </DxColumn>
            <DxColumn data-field="NombreCompletoInstalacion" :caption="$t('oscilos.grid.nombre_instalacion')"
                sortOrder="asc" :sortIndex="1">
            </DxColumn>
            <DxColumn data-field="Nombre" :caption="$t('oscilos.grid.nombre')" sortOrder="asc" :sortIndex="2">
            </DxColumn>
            <!-- <DxColumn data-field="NumeroSerie" :caption="$t('oscilos.grid.numero_serie')" v-if="vistaAdministracion">
            </DxColumn> -->
            <DxColumn data-field="IdOsciloEstadoTipo" :caption="$t('oscilos.grid.id_oscilo_estado_tipo')"
                cell-template="cellTemplateOsciloEstadoTipo" :allow-header-filtering="true" :allow-filtering="false"
                sortOrder="desc" :sortIndex="0">
                <DxLookup :data-source="lookupOsciloEstadoTipoModel" value-expr="Id" display-expr="Nombre" />
            </DxColumn>
            <DxColumn data-field="IpPublica" :caption="$t('oscilos.grid.ip_publica')"
                cell-template="cellTemplateIpPublica"
                :allow-sorting="true"
                :allow-filtering="true"
                :allow-header-filtering="true">
            </DxColumn>
            <DxColumn data-field="FechaUltimoIntentoDescarga"
                :caption="$t('oscilos.grid.fecha_ultimo_intento_descarga')" v-if="vistaAdministracion"
                v-bind="dateTimeDxColumnProps()">
            </DxColumn>
            <DxColumn data-field="DescargaHabilitada" :caption="$t('oscilos.grid.descarga_habilitada')"
                v-if="vistaAdministracion" cell-template="cellTemplateDescargaHabilitada">
            </DxColumn>
            <DxColumn data-field="EnStandby" :caption="$t('oscilos.grid.en_standby')" v-if="vistaAdministracion"
                cell-template="cellTemplateEnStandby">
            </DxColumn>
            <!-- <DxColumn data-field="NombreEmpresaInstalacion" :caption="$t('oscilos.grid.empresa_instaladora')">
            </DxColumn> -->
            <DxColumn data-field="NombreZonaInstalacion" :caption="$t('oscilos.grid.nombre_zona_instalacion')">
            </DxColumn>
            <DxColumn data-field="FechaInstalacion" :caption="$t('oscilos.grid.fecha_instalacion')"
                v-bind="dateTimeDxColumnProps()">
            </DxColumn>
            <DxColumn data-field="NombreJefeZona" :caption="$t('oscilos.grid.nombre_jefe_zona')">
            </DxColumn>
            <DxColumn data-field="TelefonoJefeZona" :caption="$t('oscilos.grid.telefono_jefe_zona')">
            </DxColumn>
            <DxColumn data-field="EmailJefeZona" :caption="$t('oscilos.grid.email_jefe_zona')">
            </DxColumn>
            <template #btnVerOscilo>
                <DxButton :hint="$t('oscilos.grid.toolbar.ver_oscilo')" icon="fa-solid fa-info-circle"
                    styling-mode="text" type="default" @click="verOscilo" :disabled="!hayUnOsciloSeleccionado" />
            </template>
            <template #btnAnadirOscilo>
                <DxButton :hint="$t('oscilos.grid.toolbar.anadir_oscilo')" icon="fa fa-plus" styling-mode="text"
                    type="default" @click="anadirOscilo" />
            </template>
            <template #btnEditarOscilo>
                <DxButton :hint="$t('oscilos.grid.toolbar.editar_oscilo')" icon="fa fa-pencil" styling-mode="text"
                    type="default" @click="editarOscilo" :disabled="!hayUnOsciloSeleccionado" />
            </template>
            <template #btnDarDeBajaOscilo>
                <DxButton :hint="$t('oscilos.grid.toolbar.dar_de_baja_oscilo')" icon="fa fa-trash" styling-mode="text"
                    type="default" @click="darDeBajaOscilo" :disabled="!hayUnOsciloSeleccionado" />
            </template>
            <template #btnActualizarRejilla>
                <DxButton :hint="$t('oscilos.grid.toolbar.actualizar_rejilla')" @click="refresh(grid!.instance!)"
                    icon="fa-solid fa-sync" styling-mode="text" type="default" />
            </template>
            <template #btnRestaurarRejilla>
                <DxButton :hint="$t('oscilos.grid.toolbar.restaurar_rejilla')" @click="reset(grid!.instance!)"
                    icon="fa-solid fa-filter-slash" styling-mode="text" type="default" />
            </template>
            <template #cellTemplateOsciloEstadoTipo="{ data }">
                <!-- {{ lookupOsciloEstadoTipoModel!.first(x => x.Id == (data.data as OsciloDetalleModel).IdOsciloEstadoTipo).Nombre }} -->
                <span :class="obtenerClaseOsciloEstadoTipo((data.data as OsciloDetalleModel).IdOsciloEstadoTipo)">
                    {{ getNombreOsciloEstadoTipo((data.data as OsciloDetalleModel).IdOsciloEstadoTipo) }}
                </span>
            </template>
            <template #cellTemplateDescargaHabilitada="{ data }">
                <span :class="obtenerClaseDescargaHabilitada((data.data as OsciloDetalleModel).DescargaHabilitada)">
                    <i v-if="(data.data as OsciloDetalleModel).DescargaHabilitada" class="fa-solid fa-check"></i>
                </span>
            </template>
            <template #cellTemplateEnStandby="{ data }">
                <span :class="obtenerClaseEnStandby((data.data as OsciloDetalleModel).EnStandby)">
                    <i v-if="(data.data as OsciloDetalleModel).EnStandby" class="fa-solid fa-check"></i>
                </span>
            </template>
            <template #cellTemplateIpPublica="{ data }">
                <span>
                    {{ obtenerIpPublicaCompleta(data.data as OsciloDetalleModel) }}
                </span>
            </template>
        </DxDataGrid>
    </div>
</template>

<script setup lang="ts">
import {
    DxAsyncRule, DxColumn, DxDataGrid, DxEditing, DxEmailRule, DxFormItem, DxRemoteOperations, DxRequiredRule, DxLookup, DxHeaderFilter, DxFilterRow,
    DxFilterPanel, DxPaging, DxPager, DxCustomRule, DxToolbar, DxItem, DxPopup, DxSelection, DxExport, type DxDataGridTypes, DxColumnChooser
} from "devextreme-vue/data-grid";
import { computed, onMounted, ref } from "vue";
import { useIntl } from '@services/i18n';
import { DxButton } from "devextreme-vue/button";
import type { SaveOsciloModalModel } from "./Model";
import SaveOsciloModal from "./SaveOsciloModal.vue";
import { useApi } from '@/.shared/.api/integration';
import { OsciloEstadoTipoEnum } from "@/model/oscilo";
import type CustomStore from "devextreme/data/custom_store";
import { useRouter } from '@/.shared/services/routing-services';
import { useModalService } from "@/.shared/services/modal-service";
import { toastSuccess } from '@/.shared/services/notification-service';
import { useAuthorization } from "@/.shared/services/auth/authorization";
import type { EditOsciloModel, OsciloDetalleModel, OsciloEstadoTipoDetalleModel } from '@/.shared/.api';
import { dateTimeDxColumnProps } from "@/.shared/helpers/datetime-field-helper";
import type { ContentReadyEvent, RowDblClickEvent, SelectionChangedEvent } from 'devextreme/ui/data_grid';
import { refresh, reset, exportToExcel, getDefaultGridProperties, getSelectedRow } from "@/.shared/helpers/grid-helper";
import { tienePermisoOscilosAnadir, tienePermisoOscilosEditar, tienePermisoOscilosEliminar, tienePermisoOscilosVer } from "@/.shared/helpers/permission-helper";
import { getNombreOsciloEstadoTipo } from "@/.shared/helpers/oscilo-estado-tipo-helper";

const emit = defineEmits(['IdInstalacionChanged', 'DxDataGridFilterChanged']);
const props = defineProps<{ oscilosProp: OsciloDetalleModel[] | CustomStore, vistaAdministracionProp: boolean }>();
const oscilos = computed(() => props.oscilosProp);
const vistaAdministracion = computed(() => props.vistaAdministracionProp);

const api = useApi();
const intl = useIntl();
const router = useRouter();
const autho = useAuthorization();
const modalService = useModalService();

const grid = ref<DxDataGrid>();
let osciloSeleccionado = ref<OsciloDetalleModel>();
const lookupOsciloEstadoTipoModel = ref<OsciloEstadoTipoDetalleModel[]>();
let idOsciloSeleccionado = computed(() => osciloSeleccionado.value?.Id); // computed = function que devuelve algo. watch = function que no devuelve nada (void).
let hayUnOsciloSeleccionado = computed(() => osciloSeleccionado.value != null);

onMounted(async () => {
    rellenarEstadoTiposLookupDxSelectBox();
    var a: OsciloDetalleModel;
    // a.
});

async function rellenarEstadoTiposLookupDxSelectBox(): Promise<void> {
    lookupOsciloEstadoTipoModel.value = await api.callStandardApi("osciloEstadoTipoGetTodos", {});
}

function onRowDblClick(e: RowDblClickEvent): void {
    if (tienePermisoOscilosVer(autho)) {
        const oscilo = e.data as OsciloDetalleModel;
        irADetalleOscilo(oscilo.Id);
    }
}

function onSelectionChanged(e: SelectionChangedEvent): void {
    // const idOsciloSeleccionado = e.selectedRowKeys[0];
    osciloSeleccionado.value = e.selectedRowsData[0];
    emit('IdInstalacionChanged', osciloSeleccionado.value?.IdInstalacion);
}

function onContentReady(e: ContentReadyEvent): void {
    // grid.value?.instance?.clearSelection();
    emit('DxDataGridFilterChanged');
}

function onExporting(e: DxDataGridTypes.ExportingEvent): void {
    console.log('Iniciando exportación...', e);
    
    try {
        // Personalizar los datos antes de la exportación para formatear correctamente la IP pública
        const dataSource = e.component.getDataSource();
        const data = dataSource.items();
        
        console.log('Datos obtenidos:', data.length, 'registros');
        
        // Modificar los datos para incluir el puerto en la IP pública
        const modifiedData = data.map((item: OsciloDetalleModel) => ({
            ...item,
            IpPublica: obtenerIpPublicaCompleta(item)
        }));
        
        console.log('Datos modificados:', modifiedData.length, 'registros');
        console.log('Ejemplo de IP formateada:', modifiedData[0]?.IpPublica);
        
        // Guardar el dataSource original
        const originalDataSource = e.component.option('dataSource');
        
        // Cambiar temporalmente el dataSource con los datos modificados
        e.component.option('dataSource', modifiedData);
        
        // Usar setTimeout para permitir que DevExtreme procese el cambio de dataSource
        setTimeout(() => {
            try {
                // Usar la función exportToExcel del helper
                exportToExcel(e, 'Oscilos');
                
                // Restaurar el dataSource original después de la exportación
                setTimeout(() => {
                    e.component.option('dataSource', originalDataSource);
                    console.log('DataSource restaurado');
                }, 500);
                
                console.log('Exportación completada');
            } catch (exportError) {
                console.error('Error durante la exportación:', exportError);
                // Restaurar el dataSource en caso de error
                e.component.option('dataSource', originalDataSource);
            }
        }, 100);
        
    } catch (error) {
        console.error('Error durante la preparación de la exportación:', error);
    }
}

async function verOscilo(): Promise<void> {
    if (hayUnOsciloSeleccionado.value)
        irADetalleOscilo(idOsciloSeleccionado.value!);
}

function irADetalleOscilo(idOsciloSeleccionado: number): void {
    router.push(intl.i18Route({ name: "oscilo-detalle-view", params: { id: idOsciloSeleccionado } }));
}

async function anadirOscilo(): Promise<void> {
    let osciloCreate = {} as SaveOsciloModalModel;
    const result = await modalService.showModal(SaveOsciloModal, { osciloProp: osciloCreate }, { title: intl.i18n.t('oscilos.grid.boton_anadir_oscilo'), maxWidth: "600", maxHeight: "70vh" });
    if (result)
        refresh(grid.value!.instance!);
}

async function editarOscilo(): Promise<void> {
    if (hayUnOsciloSeleccionado.value) {
        const oscilo = osciloSeleccionado.value!;
        const osciloEdit: SaveOsciloModalModel = {
            Id: oscilo.Id,
            IdInstalacion: oscilo.IdInstalacion,
            Nombre: oscilo.Nombre,
            NumeroSerie: oscilo.NumeroSerie,
            NombreEmpresaInstalacion: oscilo.NombreEmpresaInstalacion,
            FechaInstalacion: oscilo.FechaInstalacion,
            IpPublica: oscilo.IpPublica,
            Puerto: oscilo.Puerto,
            FrecuenciaDescargaEnMinutos: oscilo.FrecuenciaDescargaEnMinutos,
            DescargaHabilitada: oscilo.DescargaHabilitada,
            EnStandby: oscilo.EnStandby,
            Adjuntos: [],
            AdjuntosExistentes: oscilo.Adjuntos
        };
        const result = await modalService.showModal(SaveOsciloModal, { osciloProp: osciloEdit }, { title: intl.i18n.t('oscilos.grid.boton_editar_oscilo'), maxWidth: "600", maxHeight: "70vh" });
        if (result) {
            const dxDataGrid = grid.value!.instance!;
            await refresh(dxDataGrid);
            const suceso = await getSelectedRow(dxDataGrid) as OsciloDetalleModel;
            osciloSeleccionado.value = suceso;
        }
    }
}

async function darDeBajaOscilo(): Promise<void> {
    if (hayUnOsciloSeleccionado.value) {
        const result = await modalService.messageBox(intl.i18n.t('oscilos.popup_dar_de_baja_oscilo.mensaje_confirmacion_dar_de_baja'), intl.i18n.t('oscilos.popup_dar_de_baja_oscilo.titulo_confirmacion_dar_de_baja'), 'yesNo', 'warning');
        if (result === 'yes') {
            await api.callStandardApi("osciloDelete", { showLoading: true }, { Id: osciloSeleccionado.value!.Id });
            refresh(grid.value!.instance!);
            toastSuccess(intl.i18n.t('oscilos.popup_dar_de_baja_oscilo.mensaje_oscilo_dado_de_baja'));
        }
    }
}

function obtenerClaseOsciloEstadoTipo(idOsciloEstadoTipo: number): string {
    switch (idOsciloEstadoTipo) {
        case OsciloEstadoTipoEnum.NoInicializado:
            return "oscilo-estado-tipo--no-inicializado";
        case OsciloEstadoTipoEnum.Funcionando:
            return "oscilo-estado-tipo--funcionando";
        case OsciloEstadoTipoEnum.Standby:
            return "oscilo-estado-tipo--standby";
        case OsciloEstadoTipoEnum.SucesoNuevo:
            return "oscilo-estado-tipo--suceso-nuevo";
        case OsciloEstadoTipoEnum.SucesoReciente:
            return "oscilo-estado-tipo--suceso-reciente";
        case OsciloEstadoTipoEnum.SucesoAntiguo:
            return "oscilo-estado-tipo--suceso-antiguo";
        case OsciloEstadoTipoEnum.Error:
            return "oscilo-estado-tipo--error";
        default:
            return "";
    }
}

function obtenerClaseDescargaHabilitada(descargaHabilitada: boolean): string {
    return descargaHabilitada ? "oscilo--descarga-habilitada" : "oscilo--no-descarga-habilitada";
}

function obtenerClaseEnStandby(enStandby: boolean): string {
    return enStandby ? "oscilo--en-standby" : "oscilo--no-en-standby";
}

function obtenerIpPublicaCompleta(oscilo: OsciloDetalleModel): string {
    if (!oscilo.IpPublica) return '';
    return oscilo.Puerto !== undefined && oscilo.Puerto !== null
        ? `${oscilo.IpPublica} : ${oscilo.Puerto}`
        : oscilo.IpPublica;
}
</script>


<style scoped lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/figma.scss";
@import "@/styles/_themevars.scss";

span[class*="oscilo-estado-tipo-"] {
    display: flex;
    padding: var(--spacing-2xs, 4px) var(--spacing-md, 16px);
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: var(--border-radius-lg, 8px);
}

span.oscilo-estado-tipo--no-inicializado {
    background: var(--background-ui-estado-no-inicializado);
}

span.oscilo-estado-tipo--funcionando {
    background: var(--background-ui-estado-funcionando);
    color: var(--text-ui-estado-on-funcionando, #FFF);
}

span.oscilo-estado-tipo--standby {
    background: var(--background-ui-estado-standby, #474747);
    color: var(--text-ui-estado-on-standby, #FFF);
}

span.oscilo-estado-tipo--suceso-nuevo {
    background: var(--background-ui-estado-suceso-nuevo, #FFC107);
    color: var(--text-warning-on-action, #000);
}

span.oscilo-estado-tipo--suceso-reciente {
    background: var(--background-ui-estado-suceso-reciente, #FF8800CC);
    color: var(--text-warning-on-action, #FFF);
}

span.oscilo-estado-tipo--suceso-antiguo {
    background: var(--background-ui-estado-suceso-antiguo, #9747FF);
    color: var(--text-ui-estado-on-suceso-antiguo, #FFF);
}

span.oscilo-estado-tipo--error {
    background: var(--background-ui-estado-error, #CB1212);
    color: var(--text-ui-estado-on-error, #FFF);
}

span.oscilo--descarga-habilitada,
span.oscilo--en-standby {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

span.oscilo--descarga-habilitada i,
span.oscilo--en-standby i {
    font-size: 1rem;
    color: var(--icon-primary-default)
}
</style>